// Shared defaults. Test, UAT, and production spread this file and override
// only the host and environment name. Client branding comes from environment.client.ts.
// @ts-ignore
import packageInfo from '../../package.json';
import { client } from './environment.client';

export const environment = {
  production: false,
  apiUrl: 'https://localhost:5071/api/',
  baseUrl: 'https://localhost:5071',
  appName: client.appName,
  clientName: client.name,
  logoUrl: client.logoUrl,
  datadogClientToken: '',
  datadogApplicationId: '',
  datadogService: `${client.datadogServicePrefix}_local`,
  ApiKey: client.apiKey,
  env: 'Local',
  version: packageInfo.version,
};
